import React,{useMemo,useState,useEffect} from 'react';
import MaterialReactTable from 'material-react-table';
import {Box,Button,Table ,Card ,CardContent ,IconButton,TableContainer,TableRow,useMediaQuery,Grid,Dialog, DialogActions,DialogContent, DialogTitle, Typography} from '@mui/material';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { ExportToCsv } from 'export-to-csv'; //or use your library of choice here
import { fetchData, postData } from '../../../../redux/apiSlice';
import {  useDispatch } from 'react-redux';
import {  useNavigate} from 'react-router-dom';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import swal from "sweetalert";
import DialogContentText from '@mui/material/DialogContentText';
import AuthUser from '../../../../Components/Auth/AuthUser';

function EligibleAffiliateList(props) {
    const dispatch = useDispatch();
    const {http,user} = AuthUser();
    const [rowSelection, setRowSelection] = useState({});
    const rowsSeleted = Object.keys(rowSelection);
   
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);
    const [columnVisibility, setColumnVisibility] = React.useState({});
    const [freez, setFreez] = React.useState(false);
    const navigate = useNavigate();
    const [saveDisable, setSaveDisable] = useState(false);    
    const [confirmationOpen, setConfirmationOpen] = useState(false);
    const tablePreferencesArray = {
    }
   const isMobile = useMediaQuery('(max-width:600px)');
   const [fullWidth, setFullWidth] = React.useState(true);
   const [maxWidth, setMaxWidth] = React.useState('sm');
   const [companyName, setCompanyName] = useState('');
   const [openBlock, setOpenBlock] = useState(false);
   const [blockCompanyDetails, setBlockCompanyDetails] = useState({});
  
    useEffect(() => {
       getEligibleAffiliates();
    }, []);

    useEffect(() => {
        if (Object.values(columnVisibility).length > 0) {
            setColumnVisibility(columnVisibility);
        }
        //do something when the row selection changes...
    }, [rowSelection]);
    
    useEffect(() => {
        tablePreferences();
    }, [rowSelection]);
    ////////////////////////
    
    useEffect(() => {
        if (Object.values(columnVisibility).length > 0) {
            http.post('/saveTablePreferences', {
                columnArray: columnVisibility,
                userId: user.id,
                tableId: 'eligibleMediaServicesAffiliates'
            }).then((result) => {
            })
        }
    }, [columnVisibility])

    const tablePreferences = () => {
        http.get('/fetchTablePreferences/eligibleMediaServicesAffiliates')
            .then((res) => {
                if (Object.values(res.data).length == 0) {
                    setColumnVisibility(tablePreferencesArray);
                } else {
                    setColumnVisibility((JSON.parse(res.data.preferences)));
                }
            });
    }

    useEffect(() => {
        setRowSelection({});
        }, [data]);

    const getEligibleAffiliates = async() => {
        props.handleFreezStart();

        const apiUrl = '/adminMediaServices';
        const args = {
            requestType: "eligible",
        }
        const res = await dispatch(postData({ apiUrl, args })).unwrap();
        if (res) {
            if (res.success == true) {
                props.handleFreezStop();
                setData(res.data);
            } else {
                props.handleFreezStop();
            }
        } else {
            swal({
                title: "Failed",
                text: "Network Error",
                icon: "error",
                button: "Ok",
            });
        }
    }
    
    // const handleFreezStop = () => {
    //     setFreez(false);
    // };
    // const handleFreezStart = () => {
    //     setFreez(true);
    // };

    const checkUserRole = () => {
        const loginUser = JSON.parse(localStorage.getItem('user'));
        if(loginUser.roles_id >= 3 && loginUser.roles_id !== 15 ) {
            swal({
                title: "Failed",
                text: "This action is unauthorized.",
                icon: "error",
                button: "Ok",
            })
            navigate('/login');
            return false;
        }else{
            return true;
        }
    };

    const handleClickOpenBlock = (companyDetailsData) => {
        setBlockCompanyDetails(companyDetailsData);
        setOpenBlock(true);
    };

    const closeBlockPopup = () => {
        setBlockCompanyDetails({});
		setOpenBlock(false)
	}

   const columns = useMemo(() => {
        //column definitions...
        const baseColumns = [
            {
                accessorFn: (data) => `${data.company?.company_name?.trim() ?? ''}`,
                id: 'company_name',
                header: 'Company Name',
                size: 50,
                enablePinning: true,
            },
            {
                accessorFn: (data) =>
                    data.company && data.reference_affiliates
                        ? `${data.reference_affiliates.first_name} ${data.reference_affiliates.last_name}`
                        : '',
                enableClickToCopy: true,
                id: 'affiliate_name',
                header: 'Affiliate Name',
                size: 150,
                Cell: ({ row }) =>
                    row.original.company && row.original.reference_affiliates
                        ? `${row.original.reference_affiliates.first_name} ${row.original.reference_affiliates.last_name}`
                        : '',
            },
            {
                accessorFn: (data) => `${data.monthly_active_count?.count ?? '0'}`,
                id: 'active_enrollments',
                header: 'Active Enrollments',
                size: 50,
                Cell: ({ row }) => row.original.monthly_active_count?.count ?? '0',
            },
        ];

        // Only add the Action column if the user is not role_id 15
        if (user.roles_id !== 15) {
            baseColumns.push({
                id: 'action',
                header: 'Action',
                size: 50,
                Cell: ({ row }) => (
                    <div
                        style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                        onClick={() => handleClickOpenBlock(row)}
                    >
                        <img
                            src={require('../../../../assets/images/block.png')}
                            style={{ width: '10%' }}
                            alt="Block"
                        />
                        <span style={{ marginLeft: '10px' }}>Block Media Services</span>
                    </div>
                ),
            });
        }
        return baseColumns;
    });

    const handleTablePreferences = (data) =>{
        if(Object.values(data).length>0){
            setColumnVisibility(data);
        }
        setIsLoading(false);
    }
      //csv option start here
    const csvOptions = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        useBom: true,
        useKeysAsHeaders: false,
        fileName: 'Media Services Eligible Companies',
        headers: ['Company Name','Affiliate Name','Active Enrollments'],
    };
    
    const csvExporter = new ExportToCsv(csvOptions);
    const handleExportData = (data) => {
        var check = checkUserRole();
        if(check === true) {
            const exportedData = [];
            data.forEach((row) => {
            const mainTableRow = {
              companyName: `${row.original.company.company_name}` || 'N/A',
              affiliateName: `${row.original.reference_affiliates ? (row.original.reference_affiliates.first_name + row.original.reference_affiliates.last_name) : 'N/A' }` || 'N/A',
              ActiveEnrollments: `${row.original.monthly_active_count ? row.original.monthly_active_count.count : 0}`,
            };
            exportedData.push(mainTableRow);
        //  exportedData.push({});
       });
      
       const csvContent = convertToCSV(exportedData);
      // Create a Blob object from the CSV data
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
      
      // Create a download link element
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = csvOptions.fileName + '.csv';
      
      // Append the link to the document body
      document.body.appendChild(link);
      
      // Programmatically click the link to trigger the file download
      link.click();
      
      // Clean up the temporary URL and remove the link from the document
      URL.revokeObjectURL(link.href);
      link.remove();
      };
    }
    
    const convertToCSV = (data) => {
      const headers = csvOptions.headers.join(',') + '\n';
    
      const rows = data.map((row) => {
        return Object.values(row).map((value) => {
          // Handle any necessary formatting or escaping of values
          // For simplicity, we assume all values are already properly formatted
    
          // Wrap the value with double quotes if it contains a comma
          if (typeof value === 'string' && value.includes(',')) {
            return `"${value}"`;
          }
    
          return value;
        }).join(',');
      }).join('\n');
    
      return headers + rows;
      };
      //csv end here

    const enableServices = () => {
        var check = checkUserRole();
        if(check === true) {
          if(rowsSeleted.length <= 0) {
            alert('Please select at least one company');
            return false;;
          }
          setSaveDisable(true);
          setConfirmationOpen(true);
            if(rowsSeleted.length == 1) {
                const companyObj = data.find(company => company.company_master_id == rowsSeleted[0]);
                setCompanyName(companyObj.company? companyObj.company.company_name : '');
            }
        } 
    };

    const closeConfirmationPopup = () => {
        setSaveDisable(false);
		setConfirmationOpen(false)
	}
    
    const enableServicesForSelectedCompanies = async() => {
        var check = checkUserRole();
        if(check === true) {
            setConfirmationOpen(false);
            props.handleFreezStart();
            const apiUrl = '/enableMediaServicesCompanies';
            const args = {
                companyIds: rowsSeleted,
            };
            const res = await dispatch(postData({ apiUrl, args })).unwrap();
            if (res) {
                if(res.success === true){
                    swal({
                        title: "Success",
                        text: res.message,
                        icon: "success",
                        button: "Ok",
                    })
                    getEligibleAffiliates();
                    
                }else{
                    alert("something went wrong ! Please Try Later !");
                    
                }
                setSaveDisable(false);
                props.handleFreezStop();
            }
        }
    }   
    
    
     const blockMediaServices = async() => {
        var check = checkUserRole();
        if(check === true) {
            // closeBlockPopup();
            props.handleFreezStart();
            const apiUrl = '/blockMediaServices';
            const args = {
                companyId: blockCompanyDetails.original.company_master_id,
                blocked:1,
            };
            const res = await dispatch(postData({ apiUrl, args })).unwrap();
            if (res) {
                if(res.success === true){
                    swal({
                        title: "Success",
                        text: res.message,
                        icon: "success",
                        button: "Ok",
                    })
                    closeBlockPopup();
                    getEligibleAffiliates();
                    
                }else{
                    closeBlockPopup();
                    alert("something went wrong ! Please Try Later !");
                    
                }
                props.handleFreezStop();
            }
        }
    } 
    return (
        <>
            <MaterialReactTable
                columns={columns}
                data={data}
                enableColumnFilterModes
                
                enableGrouping={false}
                enablePinning={false}
                enableRowSelection={true}
                onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                getRowId={(row) => row.company.id}
                state={{ columnVisibility, rowSelection }} //pass our managed row selection state to the table to use
                initialState={{
                    showColumnFilters: false,
                    density: 'compact',
                }}
                onColumnVisibilityChange={(state) => { setColumnVisibility(state) }}
                positionToolbarAlertBanner="bottom"
                enableDensityToggle={false}
                muiTablePaperProps={{
                    sx: { backgroundColor: "white" },
                    }}
                    muiTableHeadCellProps={{
                        sx: {
                            backgroundColor: "#2A68B3",
                            color: "white",
                            fontWeight: "bold",
                            '& .MuiIconButton-root': {
                                color: 'white',
                                '&:hover': {
                                  color: 'white',
                                  backgroundColor: 'transparent', // avoid default hover bg
                                },
                                '&:focus': {
                                  color: 'white',
                                },
                                '&:active': {
                                  color: 'white',
                                },
                              },
                              '& .MuiSvgIcon-root': {
                                color: 'white',
                              },
                        },
                    }}
                //top csv option
                renderTopToolbarCustomActions={({ table }) => (
                    <Box
                        sx={{ display: 'flex', gap: '1rem', p: '0.5rem', flexWrap: 'wrap' }}
                    >
                        <Button
                        color="primary"
                        sx={{borderRadius:"10px",fontWeight:"bold",fontSize:"large",minWidth:isMobile?100:130,border:"1px solid #2A68B3"}}
                        disabled={table.getPrePaginationRowModel().rows.length === 0}
                        //export all rows, including from the next page, (still respects filtering and sorting)
                        onClick={() =>
                            handleExportData(table.getPrePaginationRowModel().rows)
                        }
                        variant="outlined"
                        >
                        CSV
                        </Button>
                    </Box>
                    )
                }
            />
             <Grid container item lg={12} md={12} sm={12} xs={12} mt={2} id='actionDiv'>
                <Button variant="contained" color='primary' disabled={saveDisable} onClick={enableServices} sx={{minWidth:250,borderRadius:"10px",fontWeight:"bold",}}>Enable Media Services</Button>
            </Grid>
            <Dialog
                open={confirmationOpen}
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        setConfirmationOpen(false)
                    }
                    }}
                fullWidth={fullWidth}
                maxWidth={maxWidth}
                PaperProps={{
                    sx: {
                      top: 0,
                      borderRadius:"20px",
                      boxShadow:"0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                    },

                  }}>
                <Card width={"100%"} sx={{overflow:isMobile?"scroll":"auto"}}>
                    <CardContent>
                        <Grid container item lg={12} md={12} sm={12} xs={12} display={"flex"} justifyContent={"space-between"} p={1}>
                            <Grid item lg={6} md={6} sm={10} xs={10}>
                                <Typography variant='h5' fontWeight={"bold"}>Enable Media Services</Typography>
                            </Grid>
                            <Grid item lg={6} md={6} sm={2} xs={2} textAlign={"right"}>
                                <IconButton edge="end" onClick={closeConfirmationPopup}>
                                    <img src={require("../../../../assets/images/close.png")}
                                        style={{ height: "25px" }}
                                        alt="close" />
                                </IconButton>
                            </Grid>
                        </Grid>
                        <Grid container item lg={12} md={12} sm={12} xs={12} mt={1} mb={2} p={1}>
                            <Typography variant='body1' sx={{ textTransform: 'capitalize',textAlign:"left" }}>Are you sure you want to enable Media Services for {rowsSeleted.length == 1 ?  companyName  : rowsSeleted.length + ' companies'}  ?</Typography>
                        </Grid>
                        <Grid container item lg={12} md={12} sm={12} xs={12} display={"flex"} gap={1} justifyContent={isMobile?"center":"right"} mt={2}>
                            <Button variant="outlined" color='primary' sx={{ minWidth: 150, borderRadius: "10px",fontWeight:"bold" }} onClick={closeConfirmationPopup} >
                                Cancel
                            </Button>
                            <Button  variant="contained" onClick={enableServicesForSelectedCompanies} color='primary' sx={{ minWidth: 150, borderRadius: "10px",fontWeight:"bold"}}>
                                Yes
                            </Button>
                        </Grid>
                    </CardContent>
                </Card>
            </Dialog>

            <Dialog
                open={openBlock}
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        setOpenBlock(false)
                    }
                    }}
                fullWidth={fullWidth}
                maxWidth={maxWidth}
                PaperProps={{
                    sx: {
                      top: 0,
                      borderRadius:"20px",
                      boxShadow:"0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                    },

                  }}>
                <Card width={"100%"} sx={{overflow:isMobile?"scroll":"auto"}}>
                    <CardContent>
                        <Grid container item lg={12} md={12} sm={12} xs={12} display={"flex"} justifyContent={"space-between"} p={1}>
                            <Grid item lg={6} md={6} sm={10} xs={10}>
                                <Typography variant='h5' fontWeight={"bold"}>Block Media Services</Typography>
                            </Grid>
                            <Grid item lg={6} md={6} sm={2} xs={2} textAlign={"right"}>
                                <IconButton edge="end" onClick={closeBlockPopup}>
                                    <img src={require("../../../../assets/images/close.png")}
                                        style={{ height: "25px" }}
                                        alt="close" />
                                </IconButton>
                            </Grid>
                        </Grid>
                        <Grid container item lg={12} md={12} sm={12} xs={12} mt={1} mb={2} p={1}>
                            <Typography variant='body1' sx={{ textTransform: 'capitalize',textAlign:"left" }}>Are you sure you want to block Media Services for {blockCompanyDetails.original ? blockCompanyDetails.original.company? blockCompanyDetails.original.company.company_name : '' : ''}?</Typography>
                        </Grid>
                        <Grid container item lg={12} md={12} sm={12} xs={12} display={"flex"} gap={1} justifyContent={isMobile?"center":"right"} mt={2}>
                            <Button variant="outlined" color='primary' sx={{ minWidth: 150, borderRadius: "10px",fontWeight:"bold" }} onClick={closeBlockPopup} >
                                Cancel
                            </Button>
                            <Button  variant="contained" onClick={blockMediaServices}  style={{ backgroundColor: 'red', color: 'white',minWidth: 150,borderRadius: "10px",fontWeight:"bold" }}>
                                Yes
                            </Button>
                        </Grid>
                    </CardContent>
                </Card>
            </Dialog>
        </>
    );
}

export default EligibleAffiliateList;